<template lang="pug">
  app-card(data-aos="fade-up" data-aos-duration="300")
    app-card-header
      v-row.flex-nowrap(no-gutters align="baseline")
        .col-auto.sud-case-status-color(v-bind:style="{ background: statusColor }")
        .col.ml-2(v-line-clamp="1") {{ !isLimitView ? courtCase.status.title : "" }}
        .col-auto.text-no-wrap {{ shortDate }}
    app-card-body.pa-4(v-if="!isLimitView")
      app-card-headline.case-list-item__headline(v-line-clamp="2" v-html="caseNumber")
      app-card-title.case-list-item__category(v-line-clamp="3") 
        | {{ courtCase.mainLawArticle ? courtCase.mainLawArticle + ' УК РФ' : courtCase.caseCategory ? courtCase.caseCategory.title : 'Категория не определена' }}
        //- | {{ courtCase.caseCategory ? courtCase.caseCategory.title : courtCase.mainLawArticle ? courtCase.mainLawArticle + ' УК РФ' : 'Категория не определена' }}
      app-card-caption.case-list-item__search-member(v-if="hasSearchedMember") Есть совпадения среди участников
    app-card-body.pa-4(v-else)
      app-card-title.case-list-item__headline(v-line-clamp="2" v-html="caseNumber")

</template>

<script>
import moment from 'moment'
import colors from "@/assets/data/CaseStatusColors.json"

export default {
  name: "case-list-item",
  props: {
    courtCase: Object,
    highlightText: String,
    isLimitView:Boolean
  },

  computed: {
    shortDate() {
      return (this.isLimitView && this.courtCase.eventDate) ? moment(this.courtCase.eventDate).format("DD.MM.YYYY HH:mm") : moment(this.courtCase.createDate).format("DD.MM.YYYY")
    },
    statusColor() {
      return (this.courtCase.status.color in colors) ? colors[this.courtCase.status.color] : colors.default
    },
    caseNumber () {
      if (this.highlightText && this.courtCase.number.toLowerCase().includes(this.highlightText)) {
        return this.courtCase.number.replace(new RegExp(this.highlightText, "gi"), match => {
          return `<span style="color: #00BCD4; margin: 0px 1px;">${match}</span>`
        })
      }
      return this.courtCase.number
    },
    hasSearchedMember () {
      return this.highlightText && this.courtCase.memberNames.find(name => name.toLowerCase().includes(this.highlightText))
    }
  }
}
</script>

<style scoped>
.case-list-item__headline {
  height: 36px;
}
.case-list-item__category {
  font-family: Roboto Condensed;
  height: 54px;
}
.case-list-item__search-member {
  color: #19AFDE;
}
</style>